import type { IComponentController } from "angular";
import type { IScheduleException } from "App/Modules/Models/Models/IScheduleException";
import type { ISite } from "App/Modules/Models/Models/ISite";

export default class SiteConfigurationGroupScheduleExceptionInfoComponentController implements IComponentController {
    public exceptions: IScheduleException[];

    public site: ISite;
}
